import { boot } from 'quasar/wrappers'
import { fpjsPlugin } from '@fingerprintjs/fingerprintjs-pro-vue-v3';

export default boot(({ app }) => {
    app.use(fpjsPlugin, {
        loadOptions: {
            apiKey: process.env.FINGERPRINT_API_KEY,
            endpoint: process.env.FINGERPRINT_ENDPOINT,
            scriptUrlPattern: process.env.FINGERPRINT_SCRIPT_URL_PATTERN
        }
    })
})
